module.exports = __webpack_public_path__ + "img/txt.89832898.svg";